import { useState } from 'react';

import { FaiType } from '@app-types/plan';

import { UpsellModalContainerProps } from '@components/fai-upsell-modal';

import { getUpsellCombination, getUpsellOffer } from '@helpers/fai-upsell';
import { globalFaiUpsellConfig } from '@helpers/fai-upsell-config';

import { sendUpsellModalClick, sendUpsellModalClose, sendUpsellModalOpen } from '@eligibility/helpers';

interface UseUpsellModalProps {
    defaultPlans: FaiType[];
}

export function useUpsellModal({ defaultPlans }: UseUpsellModalProps) {
    const [upsellModal, setUpsellModal] = useState<UpsellModalContainerProps | null>(null);

    const showUpsellModal = (
        currentPlan: FaiType,
        onAddToCart: (gencode: string, autoAdd?: string[]) => Promise<void>,
        autoAdd?: string[],
    ) => {
        const upsellOffer = getUpsellOffer(defaultPlans, currentPlan, globalFaiUpsellConfig);
        const upsellCombination = getUpsellCombination(currentPlan, globalFaiUpsellConfig);

        if (upsellOffer && upsellCombination?.modalComponentType) {
            sendUpsellModalOpen({
                universe: 'Boutique_fai',
                marketLine: 'Fai',
            });

            setUpsellModal({
                type: upsellCombination.modalComponentType,
                clickedOffer: currentPlan,
                upsellOffer,
                onClose: () => {
                    sendUpsellModalClose({
                        universe: 'Boutique_fai',
                        marketLine: 'Fai',
                    });
                    setUpsellModal(null);
                },
                onAddOffer: async (_offer) => {
                    const offer = _offer as FaiType;
                    sendUpsellModalClick(
                        {
                            universe: 'Boutique_fai',
                            marketLine: 'Fai',
                        },
                        `${upsellOffer.rangeNg}${upsellOffer.commercialSeries}`,
                    );
                    await onAddToCart(offer.gencode, autoAdd);
                    setUpsellModal(null);
                },
            });
            return true;
        }

        return false;
    };

    return {
        upsellModal,
        showUpsellModal,
    };
}
